import React from "react";
import lunr from "lunr";
import { Link, navigate } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import info from '../info.json';
import { IconSearch } from "@tabler/icons-react";
import ProductCard from "./product-card";
const minCharacters = 3;
const contentCharLimit = 200;

function getIndex(flowers) {
  return lunr(function () {

    this.pipeline.remove(lunr.stemmer);
    this.ref('id');
    this.field('title');
    this.field('slug');
    this.field('color');
    this.field('headSize');
    this.field('length');

    flowers.forEach(flower => {
      this.add({
        id: flower.id,
        title: flower.title,
        slug: flower.slug,
        color: flower.flowerExtraFields.color,
        headSize: flower.flowerExtraFields.headSize,
        length: flower.flowerExtraFields.length
      });
    });

  });
}

function getIndexCat(categories) {
  return lunr(function () {

    this.pipeline.remove(lunr.stemmer);
    this.ref('id');
    this.field('name');
    this.field('label');
    
    categories.forEach(category => {
      this.add({
        id: category.id,
        name: category.name,
        slug: category.slug,
        label: category.categoryFields.label
      });
    });

  });
}



export default function SearchResults(props) {

  const { nodes: flowers } = props.flowers;
  const { nodes: categories } = props.categories;
  
  const [query, setQuery] = React.useState('');
  const [idx, setIdx] = React.useState(null);
  const [catIdx, setCatIdx] = React.useState(null);

  const inputRef = React.useRef(null);
  const product = React.useRef(null)
  const search = React.useRef(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  
  function focus(e) {
        e.stopPropagation(); // Stop event propagation here
        handleFocus();
  }

  React.useEffect(() => {
    const idx = getIndex(flowers);
    const catIdx = getIndexCat(categories);

    setIdx(idx);

    setCatIdx(catIdx);


  }, [flowers, categories]);

  React.useEffect(() => {
    
    let slider = document.getElementById('slider-search')

    if(slider){
      slider.addEventListener('wheel', (e)=>{
        e.preventDefault()
        slider.scrollLeft += (e.deltaY *0.1);   

      })

      slider.removeEventListener('wheel', (e)=>{
          e.preventDefault()
          slider.scrollLeft += (e.deltaY *0.1);   

      })
    }

  }, [query])

  let results = [];
  let resultsCategories = [];
  
  if (idx && query && query.length >= minCharacters) {
    results = idx.search(`${query}*`);

    resultsCategories = catIdx.search(`${query}*`);
  }

  const [inputFocused, setInputFocused] = React.useState(false)

  React.useEffect(()=>{

    var searchbar =document.getElementById('search-bar')
    var input_focused = document.activeElement === searchbar && document.hasFocus();

    function focusInputSet() {
      setInputFocused(inputFocused)
 
    }


    document.addEventListener('click', focusInputSet)
    document.removeEventListener('click', focusInputSet)
    

  })

  React.useEffect(()=>{
    console.log(search.current);
    let scrollEl = search.current
    
    if (!scrollEl) return; // skip if not mounted

    
    function smoothScroll(e){

      search.current.scrollLeft += (e.deltaX * 0.4)
      
    }


    search.current.addEventListener('wheel', (e)=>smoothScroll(e))
    


  }, [query])


  return (
    <div>
      <div className='flex flex-row py-[1vh] px-[20px] border-b border-charcoal gap-3 -z-20 bg-cream'>
          <IconSearch className='mt-[1px] align-middle' />

          <input 
            type="text" 
            onChange={e => {
              setQuery(e.target.value.replace(/[|&!*#;$=%^_/?@":~<>()+,]/g, ""));
            }}
            placeholder={info.header.searchBar.text}
            id="search-bar"
            ref={inputRef} onTouchEnd={(e)=>{focus(e)}}
            className='flex-1 bg-cream uppercase placeholder:text-gray border-none rounded-none focus:outline-none'
          />

     
        <p className="truncate">
          {/* {query.length < minCharacters && `Please type at least ${minCharacters} characters`} */}
          {/* {!!results.length && query.length >= minCharacters && !!resultsCategories.length && `Showing ${results.length + resultsCategories.length} results for “${query}”`} */}
          {!results.length && query.length >= minCharacters && `No results found for “${query}”`}


        </p>
      </div>
      <section>

        {query.length < minCharacters && inputFocused && 
          <div className='flex flex-col items-center border-b border-charcoal pt-6 pb-10'>
            <span className="pt-4">{`Please type at least ${minCharacters} characters`}</span> 
          </div>
        }

        {query.length >= minCharacters &&
          <div className='flex flex-col items-center border-b border-charcoal pt-6 pb-10'>
              {resultsCategories.length > 0 ?
              <div className="flex flex-col justify-center items-center">
                <span className='uppercase underline-offset-8 mb-6 bold text-xl'>Releated Categories</span>      
                <div className='flex flex-row flex-wrap items-center justify-center px-6 gap-4 md:gap-12'>
                    {resultsCategories.map((o, i) => {
                      const category = categories.find(category => category.id === o.ref);
                      if(i<10 && category.categoryFields != null){
                        return (
                            <div className='group' key={category.id}>
                              <Link 
                                    to={`/category/${category.slug}`}
                                    // onTouchEnd={()=>{navigate(`/category/${category.slug}`)}}
                                    // onClick={()=>{navigate(`/category/${category.slug}`)}}
                                    className='uppercase'>
                                      {/* {category.categoryFields ? category.categoryFields.label : category.name} */}
                                      {category.categoryFields != null && category.categoryFields.label}
                              </Link>      
                              <span className='block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-charcoal'></span>
                            </div>
                        );
                      }
                    })}
                </div>
              </div> :
              <span className="pt-4">{`No results found for “${query}"`}</span>
              }

          </div>
        }

        { query.length >= minCharacters &&
          <div className='flex flex-col justify-center items-center border-b border-charcoal pt-6 pb-10'>
              {results.length > 0 ?
                <div className="flex flex-col items-center">
                  <span to='#' className='uppercase mb-6 text-xl'>Releated Products</span>      
                  <div className='flex flex-row gap-12 items-center'>
                      <div className="flex px-8 pb-4 gap-4 grid grid-flow-col auto-cols-max overflow-x-scroll overflow-y-hidden  w-fit max-w-[100vw]" id="slider-search" ref={search}>
                        {results.map((o, i) => {
                          const flower = flowers.find(flower => flower.id === o.ref);
                          if(i<20 && flower.featuredImage != null){
                            return (
                              <div key={flower.id} className="flex flex-col justify-center lg:justify-start items-center h-fit min-h-[400px] -mb-24 max-w-[150px]">
                                <ProductCard isSearch={true} image={flower.featuredImage.node.gatsbyImage} title={flower.title} slug={flower.slug} index={flower.id} size={15} isNew={flower.flowerExtraFields.isNew}/>
                                
                              {/*                                 
                                <Link ref={product} to={`/flower/${flower.slug}`} onTouchEnd={()=>{navigate(`/flower/${flower.slug}`)}} className="flower-result-card scale-100 hover:scale-[1.1] transition-scale duration-100 ease-in-out">

                                  {flower.featuredImage && <GatsbyImage image={flower.featuredImage.node.gatsbyImage} className='max-w-[200px]' />}
                                  <h4 className="text-xl uppercase text-center py-2">{flower.title}</h4>
                                </Link> */}
              
                              </div>
                            );
                          }

                        })}
                      </div>
                  </div>
                </div> : 
                  <span className="pt-4">{`No results found for “${query}"`}</span>

              }
          </div>
        }
        
      </section>
    </div>
  );
}
